export default {
  id: 131,
  title: 'Target #131 - Letter W',
  url: 'https://cssbattle.dev/play/131',
  colors: ['#E38F66', '#62306D', '#FFFBDA'],
  solution:
    '<a a><a b><a c><style>[b],[c]{left:95}body{background:#e38f66}a{position:fixed}[a],[b]{bottom:70;width:60;height:115;border:30px solid;border-top:0;border-radius:0 0 9in 9in}[a]{left:185;border-color:#fffbda}[b]{border-color:#62306d}[c]{top:70;width:30;height:30;border-radius:9in;background:#62306d;box-shadow:90px 0 #62306d,180px 0 #fffbda}</style>',
}
